import { Component, OnInit } from '@angular/core';
import { AlertService } from '../services/alert/alert.service';
import { Router } from '@angular/router';
import { ApiService } from '../services/api/api.service';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.page.html',
  styleUrls: ['./login.page.scss'],
})
export class LoginPage implements OnInit {
  countryCodes: any = [{'name': '+91','value': '91'},{'name': '+1','value': '1'}]
  data:any = {
    name: '',
    countryCode: '1',
    phone_number: ''
  }
  constructor(public alert: AlertService,private router: Router, public api: ApiService) { 

  }

  ngOnInit() {
    // this.ga.trackView('Login Page')
    // .then(() => {})
    // .catch(e => console.log(e));
  }

  OnChange(){
    console.log(this.data.countryCode)
  }

 login(){
    console.log(this.data)
    if (this.data) {

      // if(this.data.name){
      //  if(this.data.name.length < 3 || this.data.name.trim() === "" || this.data.name === null) {
      //   this.alert.presentAlert('Alert','',"Please enter the name");
      //   return;
      //   }
      // }
      // else{
      //   this.alert.presentAlert('Alert','',"Please enter the name");
      //    return;
      // }

      if (this.data.phone_no){
          if (this.data.phone_no.length < 10 || this.data.phone_no.length > 10) {
            this.alert.presentAlert('Alert','',"Please enter the phone number");
              return;
          }
      } else {
        this.alert.presentAlert('Alert','',"Please enter the phone number");
        return;
      }

      let requestData:any = {
        "country_code": this.data.countryCode,
        "mobile": this.data.phone_no,
        "request_channel": "sms"
      }

      this.api.generateOTP(requestData).subscribe(async(result:any) => {
        if(result.status == true){
          localStorage.setItem("country_code",JSON.stringify(JSON.parse(this.data.countryCode)))
          localStorage.setItem("phone_no",JSON.stringify(JSON.parse(this.data.phone_no)))
          localStorage.setItem("otp",JSON.stringify(JSON.parse(result.otp_number)))
          this.router.navigate(['/otp'])
        }
        else{
          this.alert.presentAlert('Alert','',result.message);
        }
      },(err)=>{
        console.log(err)
      });
    }
  }

  skip_login(){
    let id = localStorage.getItem('store_id')
    this.router.navigate(['/home/'+id])
  }

}
